import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const SkeletonSectionContainer = styled(Paper)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column",
	padding: "16px"
}));

export const DesignerRequestSKUSkeletonContainer = styled.div({
	display: "flex",
	gap: "48px",
	justifyContent: "space-between",
	flexDirection: "row"
});

export const SkeletonContainer = styled.div({
	width: "50%"
});
